import moment from "moment";
/**
    Model to assign the data of the Triatlón pre-sale Product
*/
export default class Product {
    constructor(product) {
        this.Amount = product.amount || 0;
        this.BookId = product.bookId || 0;
        this.Id = product.id || 0;
        this.IsOnlyHotel = product.isOnlyHotel || false;
        this.Name = product.name || "";
        this.NormalIndividual = product.normalIndividual || 0;
        this.ParkId = product.parkId || 0;
        this.parkPrefix = product.parkName || "";
        this.Pax = product.pax || 1;
        this.Promotions = product.promotions || [];
        this.RateKey = product.rateKey || "";
        this.ServiceId = product.serviceId || 0;
        this.TotalMedia = product.totalMedia || 0;
        this.VisitDate = moment().format("YYYY-MM-DD");
        this.cantidad = product.cantidad || 1;
        this.date = product.date || "";
        this.id = product.id || "";
        this.tags = product.tags || [];
        this.type = product.type || 1;
        this.saleService = product.saleService || {};
        this.hasService = product.hasService || false;
        this.isEvent = product.isEvent || false;
        this.eventDetails = product.eventDetails || {};
    }
}
